import { ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig } from '@Animation/types'
import { PLUS_3_CONFIG } from '../add-on-extra-draw/plus-3/config'
import { MI_MULTIPLIER_GUMBALL_CONFIG } from '../add-on-multiplier/michigan-kicker/gumball/config'
import {
  preLoadAssets,
  RedBallBackground,
  RedBallForeground,
  RedBallNumber,
  RedBallNumberSelector,
} from '.'
import { RedBallTextureLoader } from './texture-loader'

export const RedBallConfig: DrawAnimationMechanicConfig = {
  appSettings: {
    backgroundBaseColor: '#530304',
    backgroundGlowColor: '#E4C080',
    backgroundUrl: '/animations/red-ball/background.png',
  },
  numberSelector: RedBallNumberSelector,
  background: RedBallBackground,
  foreground: RedBallForeground,
  kenoNumber: RedBallNumber,
  multiplierAnimationConfig: MI_MULTIPLIER_GUMBALL_CONFIG,
  assetPreloader: preLoadAssets,
  extraDrawAnimationConfig: PLUS_3_CONFIG(ANIMATION_IDENTIFIERS.RED_BALL),
  textureLoader: RedBallTextureLoader,
}
